import { Controller } from "@hotwired/stimulus";
import "./component.scss"

const DISMISS_KEY = "stripe-failed-subscription-banner-dismissed";

export default class extends Controller {
  connect() {
    this.handleClose = this.markDismissed.bind(this);
    this.element.addEventListener("close", this.handleClose);

    if (!this.dismissedInSession() && !this.element.open) {
      this.element.showModal();
    }
  }

  disconnect() {
    this.element.removeEventListener("close", this.handleClose);

    if (this.element.open) {
      this.element.close();
    }
  }

  dismissedInSession() {
    return sessionStorage.getItem(DISMISS_KEY) === "true";
  }

  markDismissed() {
    sessionStorage.setItem(DISMISS_KEY, "true");
  }
}
